/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../../__generated__/schema.types';

import { CmPictureFragment } from '../../__generated__/CMPicture.fragment';
import { gql } from '@apollo/client';
import { CmPictureFragmentDoc } from '../../__generated__/CMPicture.fragment';
export type CmPicturePreviewFragment = (
  { __typename?: 'CMPictureImpl', crops: Array<{ __typename?: 'Crop', name: string, minWidth: number, minHeight: number, aspectRatio: { __typename?: 'Dimension', width: number, height: number }, sizes: Array<{ __typename?: 'Dimension', width: number, height: number } | null> }> }
  & CmPictureFragment
);

export const CmPicturePreviewFragmentDoc = gql`
    fragment CMPicturePreview on CMPicture {
  crops {
    aspectRatio {
      width
      height
    }
    name
    minWidth
    minHeight
    sizes {
      width
      height
    }
  }
  ...CMPicture
}
    ${CmPictureFragmentDoc}`;